export const CLIENT_CACHE_STORAGE_KEY = "client_cache";
export const ACCOUNTS_CACHE_STORAGE_KEY = "accounts_cache";
export const TRANSACTIONS_CACHE_STORAGE_KEY = "transactions_cache";
export const AUTHORIZATION_HOLDS_CACHE_STORAGE_KEY = "authorization_holds_cache";
export const BENEFICIARIES_CACHE_STORAGE_KEY = "recipients_cache";
export const BILL_ISSUERS_CACHE_STORAGE_KEY = "bill_issuers_cache";
export const APP_START_CACHE_STORAGE_KEY = "app_start_cache";
